module.exports = __webpack_public_path__ + "static/media/medicationTracker.d1a3233a.mp3";